import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f50d5d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Reserve a Unit", -1))
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Customer", -1))
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit Type", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit", -1))
const _hoisted_11 = { class: "form-field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reservationPrice" }, "Reservation Price($)", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "form-field" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "col"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Creating Reservation ")
const _hoisted_18 = {
  key: 1,
  class: "col"
}

import { ref } from "vue";
import moment from "moment";

import api from "@virgodev/bazaar/functions/api";
import { useRouter, useRoute } from "vue-router";
import BaseSpinner from "@/components/BaseSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: true,
  },
  unitId: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const router = useRouter();
const route = useRoute();

const unit = ref();
const errors = ref("");
const selectedCustomer = ref();
const formSubmitting = ref(false);
const reservationPrice = ref(0.0);

const formErrors = ref<Record<string, string[]>>({});
const formFields = ref({
  creator_id: ref(""),
  customer_id: "",
  move_in_on: moment().format("YYYY-MM-DD"),
  unit_type_id: "",
  unit_id: "",
});

async function getUnit() {
  errors.value = "";
  const response = await api({
    url: `units/?id=${props.unitId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unit.value = response.body;
    await getUnitType(unit.value.unit_type_id);
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnitType(id: string) {
  errors.value = "";
  const response = await api({
    url: `unit_types/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unit.value.unit_type = response.body;
    formFields.value.unit_type_id = unit.value.unit_type.id;
    let reservation = unit.value.unit_type.reservation_price;
    if (reservation) {
      reservationPrice.value = unit.value.unit_type.reservation_price;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    selectedCustomer.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getUnit();
getCustomer();
async function submitForm() {
  formFields.value.customer_id = props.customerId;
  formFields.value.unit_id = props.unitId;
  const json = JSON.parse(JSON.stringify(formFields.value));
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `reservations/?facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "POST",
    json,
  });

  formSubmitting.value = false;
  if (responseData.status === 200) {
    router.push(
      typeof route.query.next === "string"
        ? route.query.next
        : {
            name: "customer_detail_ess",
            params: {
              id: props.customerId,
              facilityId: props.facilityId,
            },
          }
    );
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      class: "large-width-centered",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      (unit.value && unit.value.unit_type)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_3, [
            (selectedCustomer.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCustomer.value.name) = $event)),
                    type: "text",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, selectedCustomer.value.name]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("input", {
                type: "text",
                disabled: "",
                value: 
            unit.value.unit_type.length +
            'x' +
            unit.value.unit_type.width +
            'x' +
            unit.value.unit_type.height
          
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unit.value.name) = $event)),
                type: "text",
                disabled: ""
              }, null, 512), [
                [_vModelText, unit.value.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((reservationPrice).value = $event)),
                type: "decimal",
                disabled: ""
              }, null, 512), [
                [_vModelText, reservationPrice.value]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          disabled: formSubmitting.value,
          type: "submit",
          class: "btn btn-text"
        }, [
          (formSubmitting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(BaseSpinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, "Create Reservation"))
        ], 8, _hoisted_15)
      ])
    ], 40, _hoisted_2)
  ], 64))
}
}

})